import React from 'react'
import calculateAbsolutePositions from './calculateAbsolutePositions'
import { CodeBlock } from './../CodeBlock'

export default class DraggableCodeList extends React.Component {
  handleMouseUp_ = e => {
    const { onCodeClick } = this.props
    if (
      onCodeClick &&
      this.selectedCode_ &&
      this.lastClickPosition &&
      this.lastClickPosition.x === e.clientX &&
      this.lastClickPosition.y === e.clientY
    ) {
      onCodeClick(this.selectedCode_)
    }
    this.selectedCode_ = null
    this.lastClickPosition = null
  }

  onClick_ = (e, codeObj) => {
    this.selectedCode_ = codeObj
    this.lastClickPosition = { x: e.clientX, y: e.clientY }
  }

  handleMouseMove_ = () => {
    const { onCodeGrab } = this.props
    if (this.selectedCode_) onCodeGrab(this.selectedCode_)
  }

  componentDidMount = () => {
    document.body.addEventListener('mouseup', this.handleMouseUp_)
    document.body.addEventListener('mousemove', this.handleMouseMove_)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mouseup', this.handleMouseUp_)
    document.body.removeEventListener('mousemove', this.handleMouseMove_)
  }

  render() {
    var { width, codes } = this.props

    if (!width) throw new Error('width must be passed in as props.')
    const dimensions = codes.map(
      // If it errors on .style here then you need to set the style for
      // all passed in children with a width and height numeric value.
      c => {
        return {
          // We have to explicitly set the width/height so that its easy to animate
          // The 8.4 here is the size of a font character, we are using a monospace
          // font so that all character widths are the same
          width: c.title
            ? (c.title.length + c.code.length + 1) * 8.4 + 40
            : (c.code.length + 1) * 8.4 + 40,
          height: 30,
        }
      },
    )

    const { positions, height } = calculateAbsolutePositions(dimensions, width)

    return (
      <div style={{ width, height: height }}>
        {codes.map((codeObj, i) => {
          var pos = positions[i]
          const { width, height } = dimensions[i]
          return (
            <CodeBlock
              key={codeObj.uniqueKey}
              {...codeObj}
              onClick={e => this.onClick_(e, codeObj)}
              style={{
                left: pos.left,
                top: pos.top,
                width: width - 2,
                height: height - 2,
              }}
            />
          )
        })}
      </div>
    )
  }
}
